import { createFileRoute } from "@tanstack/react-router";
import { categoryHead } from "@/lib/seo";
import { ProductGrid } from "@/components/ProductGrid";
import { newArrivals } from "@/lib/catalog";
import { useAllProducts } from "@/lib/use-catalog";

export const Route = createFileRoute("/nouveautes")({
  head: () =>
    categoryHead({
      path: "/nouveautes",
      title: "Nouveautés Été Femme au Maroc | SUNSET",
      description:
        "Les dernières pièces SUNSET : beachwear, kimonos, sacs et accessoires d'été. Livraison partout au Maroc, paiement à la livraison.",
      socialDescription:
        "Les dernières pièces SUNSET Concept Store pour vos journées au soleil.",
      image: "/og/nouveautes.jpg",
      name: "Nouveautés",
      products: newArrivals,
    }),
  component: NouveautesPage,
});

function NouveautesPage() {
  const products = useAllProducts(newArrivals);
  return (
    <ProductGrid
      products={products}
      title="Nouveautés"
      eyebrow="Nouvelle saison"
      subtitle="La sélection la plus récente du concept store."
    />
  );
}
